import React, { useState } from 'react';
import './LocationPrompt.css';
import Spinner from './../Spinner';

const LocationAndAddress = ({ latitude, longitude, setLatitude, setLongitude, address, setAddress }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [isFetchingLocation, setIsFetchingLocation] = useState(false);

//   const locationEnabled = latitude && longitude;

  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };


// const enableLocation = () => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           setLatitude(position.coords.latitude);
//           setLongitude(position.coords.longitude);
//         },
//         (error) => {
//           alert('Location access denied. Please enable location in your browser settings.');
//         }
//       );
//     } else {
//       alert('Geolocation is not supported by your browser.');
//     }
//   };

const enableLocation = () => {
    if (!navigator.geolocation || !navigator.permissions) {
      alert('Geolocation or Permissions API is not supported by your browser.');
      return;
    }
    setIsFetchingLocation(true); // Start loading
    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      if (result.state === 'granted' || result.state === 'prompt') {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLatitude(position.coords.latitude);
            setLongitude(position.coords.longitude);
          },
          (error) => {
            console.error('Geolocation error:', error);
            alert('Unable to fetch location. Please check your browser settings and allowAccuracy: true')
          },
         {
            timeout: 10000,
            maximumAge: 0,
            enableHighAccuracy: true,
        }
        );
      } else if (result.state === 'denied') {
        alert('Location access is denied. Please enable location permissions in your browser settings.');
      }
    }).catch((err) => {
      console.error('Permission query error:', err);
      alert('Unable to check location permissions. Please try again or check your browser settings.');
      setIsFetchingLocation(false); // Stop loading
    });
  };
  


  return (
    <div className="location-address-container">
        {/* {isFetchingLocation ? ( */}
                {/* // <p className="loading-text">Fetching location...</p> */}
                {/* <Spinner /> */}
                {/* ) : ( */}
                    {/* <div> */}
      {/* {!locationEnabled && ( */}
        <div className="location-prompt">
          <div className="location-header">
            <span className="location-icon">
                <img src="/assets/claim/gps.svg" alt="Success Icon" className="success-icon" />
            </span>
            {/* {!isFetchingLocation ? (
                <Spinner />
                ) : ( */}
                <div className='text-btn'>
                    <span className="location-text">Device Location not enabled</span>
            
                    <button type="button" className="enable-button" onClick={enableLocation}>
                        Enable
                    </button>
                </div>
        {/* )} */}


          </div>

          <p className="instruction-text">
            Tap here to enable your device Location for a <br/> better Roadside Assistance.
          </p>
        </div>
      {/* )} */}

      <div className="incident-address-container">
        <div className="accordion-header" onClick={toggleAccordion}>
          <span className="accordion-title">Add Incident Address (Optional)</span>
          <span className="accordion-icon">{isAccordionOpen ? '➖' : '➕'}</span>
        </div>

        {isAccordionOpen && (
          <textarea
            className="incident-address-textarea"
            placeholder="E.g. Area, Landmark, Pincode etc."
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            // disabled={!locationEnabled}
          />
        )}
      </div>
      {/* </div> */}
       {/* )} */}
    </div>
  );
};

export default LocationAndAddress;